const FORM_FIELD_NAMES = {
    vehicleFeatures: {
        style: 'style',
        drive: 'drive',
        transmission: 'transmission',
        fuel: 'fuel',
    },
    conditionsBody: {
        mileage: 'currentMileage',
        email: 'preferredEmail',
        exteriorColor: 'exteriorColor',
        interiorColor: 'interiorColor',
    },
};

const CLIENT_INELIGIBLE_ERRORS = {
    errorDecodingVin: 'error: decoding vin',
    errorDecodingPlate: 'error: decoding plate',
    errorNoStylesFound: 'error: no matching styles found',
    errorCallingQuoteRequest: 'error: network error calling /quote/request',
    errorClientSide: 'error: client error',
    errorInitialEligibility: 'error: initial eligibility',
    errorZipcodeIneligible: 'error: zipcode ineligible',
    errorZipcodeInvalid: 'error: zipcode invalid',
};

const HOME_PICKUP_ATTRIBUTE = 'AppraisalPickup';

export { FORM_FIELD_NAMES, CLIENT_INELIGIBLE_ERRORS, HOME_PICKUP_ATTRIBUTE };
